export class GroupedTableMutationTypes {
  public static readonly updateLastExpandedGroups = 'UPDATE_LAST_EXPANDED_GROUPS';
}
